module.exports = __webpack_public_path__ + "media/images/temp/accordion-image-7-89772bd720112513eed5451e14888d39.png";